import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Input,
  Alert
} from "reactstrap";


import classnames from "classnames";

import countries from "../../../../countries/countries.json";
import { setIdentityOnUserUpdate } from "../../../identity/reducers/identitySlice"
import { selectUserById } from "../../reducers/userSlice"
import { userApi } from "../../reducers/userSlice"

import { FormValidator } from "../../../../lib/utils/formValidator"
import profileValidators from "../../validators/ProfileValidator";

import { useParams } from "react-router-dom";

export default ({btnProfileLabel, btnPasswordLabel, onSaveProfile, onSavePassword, showPasswordTab, initWithMe = true}) => {
  const defualtPhoneCountry = "+39";

  const { id } = useParams();
  const [validators, setValidators] = useState(profileValidators);
  const [activeTab, setActiveTab] = useState("1");

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneCountry, setPhoneCountry] = useState(defualtPhoneCountry);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checkedPassword, setCheckedPassword] = useState(true);

  const dispatch = useDispatch();
  const me = useSelector((state) => state.userReducer.me);
  const user = useSelector((state) => selectUserById(state, id));

  const status = useSelector((state) => state.userReducer.status);
  const apiError = useSelector((state) => state.userReducer.error);
 
  const statusIdentity = useSelector((state) => state.identityReducer.status);
  const apiErrorIdentity = useSelector((state) => state.identityReducer.error);

  let formValidator = new FormValidator(validators);
  
  const successIconClass = "fas fa-check";
  const loadingIconClass = "fas fa-circle-notch fa-spin";
  const errorIconClass = "fas fa-exclamation-triangle";

  const btnProfileIcon = (status) => {
    let icon = null;
    switch(status) {
        case 'user/update/pending': icon = loadingIconClass; break;
        case 'user/update/rejected': icon = errorIconClass; break;
        case 'user/update/succeeded': icon = successIconClass; break;
        default: 
            icon = successIconClass; break;
    }
    return icon;
  }

  const btnSettingIcon = (status) => {
    let icon = null;
    switch(status) {
        case 'identity/update/pending': icon = loadingIconClass; break;
        case 'identity/update/rejected': icon = errorIconClass; break;
        case 'identity/update/succeeded': icon = successIconClass; break;
        default: 
            icon = successIconClass; break;
    }
    return icon;
  }  

  useEffect(() => {
    if(id !== undefined) {
      if(user === undefined) {
        dispatch( userApi.fetchById({ uid: id }) )
      } else {
        initProfile(user);
      }
    } else if(me === null) {
      dispatch(userApi.me({}));
    } else {
      if(initWithMe) {
        initProfile(me);
        dispatch(setIdentityOnUserUpdate({
            firstname: me.first_name, 
            lastname: me.last_name, 
            email: me.email, 
            avatar: (me.avatar_media && me.avatar_media.resource) ? me.avatar_media.resource.thumb : null,
        }));
      }
    }
  }, [id, me, user, dispatch]);

  const initProfile = (user) => {
      if(user) {
        setFirstname(user.first_name !== null ? user.first_name : "");
        setLastname(user.last_name ? user.last_name : "");
        setEmail(user.email ? user.email : "");
        setPhoneCountry(user.phone_country !== null ? user.phone_country : defualtPhoneCountry);
        setPhoneNumber(user.phone_number ? user.phone_number : "");
      } else {
        console.log('USER is null');
      }
  }

  
  const onInputChange = (e) => {
    formValidator.validateField(e.target.name, e.target.value)
    setValidators(formValidator.getValidators())
  };

  const showErrors = (fieldName) => {
    const errorMessages = formValidator.getFieldErrors(fieldName)

    if (errorMessages.length > 0) {
      const errors = errorMessages.map((info, index) => {
        return (
          <span className="error" key={index}>
            * {info}
            <br />
          </span>
        );
      });

      return <div className="error mb-2">{errors}</div>;
    }
    return "";
  };

  const showServerErrors = (field) => {
    const result = "";
    if ((status === 'user/create/rejected' || status === 'user/update/rejected') && apiError !== null && apiError.message[field] !== undefined) {
      return <div className="error mb-2">
        <span className="error">
          * {apiError.message[field]}
          <br />
        </span>
      </div>;
    }
    if (statusIdentity === 'identity/update/rejected' && apiErrorIdentity !== null && apiErrorIdentity.message[field] !== undefined) {
        return <div className="error mb-2">
          <span className="error">
            * {apiErrorIdentity.message[field]}
            <br />
          </span>
        </div>;
      }
    return result;
  };

  const doUpdateProfile = (event) => {
    if(onSaveProfile) onSaveProfile({
      id: id === undefined ? me.id : parseInt(id),
      firstname: firstname, 
      lastname: lastname, 
      email: email, 
      phoneCountry: phoneCountry, 
      phoneNumber: phoneNumber, 
    })

    event.preventDefault();
  };

  const doUpdatePassword = (event) => {
    setCheckedPassword( (confirmPassword === newPassword) )

    if(confirmPassword === newPassword) {
        if(onSavePassword) onSavePassword({
          email: email, 
          oldPassword: oldPassword, 
          newPassword: newPassword, 
        })
    }

    event.preventDefault();
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div>
      <Card className="p-3" >
          {
            showPasswordTab //id === undefined 
            ? <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      Setting
                    </NavLink>
                  </NavItem>
                </Nav>
              : null
          }
        
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
          <Row>
              <Col sm="12">
                <Card style={{marginBottom: 0}}>
                  <CardBody>
                    { status === "user/update/succeeded" ? ( <Alert color="success">Profile updated successfully</Alert> ) : ""}
                    { status === "user/create/succeeded" ? ( <Alert color="success">Profile create successfully</Alert> ) : ""}
                    <Form>
                      <FormGroup>
                        <Label>Firstname</Label>
                        <Input type="text" id="firstname" name="firstname" placeholder="firstname" value={firstname}
                            onChange={(e) => {
                                setFirstname(e.target.value);
                                onInputChange(e);
                            }}
                        />
                      </FormGroup>
                      {showErrors("firstname")}
                      {showServerErrors("first_name")}
                      <FormGroup>
                        <Label>Lastname</Label>
                        <Input type="text" id="lastname" name="lastname" placeholder="lastname" value={lastname}
                            onChange={(e) => {
                                setLastname(e.target.value);
                                onInputChange(e);
                            }}
                        />
                      </FormGroup>
                      {showErrors("lastname")}
                      {showServerErrors("last_name")}
                      <FormGroup>
                        <Row>
                          <Col sm="6">
                            <Label>Email*</Label>
                            <Input type="email" id="email" name="email" placeholder="your@email.xxx" value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    onInputChange(e);
                                }}
                            />
                            {showErrors("email")}
                            {showServerErrors("email")}
                          </Col>
                          <Col sm="2" style={{paddingRight: "5px"}}>
                              <Label>Phone No</Label>
                              <Input type="select" value={phoneCountry} 
                                  onChange={(e) => {
                                      setPhoneCountry(e.target.value);
                                      onInputChange(e);
                                  }}>
                              {
                                  countries.map((country, i) => {     
                                      // Return the element. Also pass key     
                                      return (<option key={country.isoCode} value={country.dialCode}>{country.name} ({country.dialCode})</option>) 
                                  })
                              }
                              </Input>
                          </Col>
                          <Col sm="4" style={{paddingLeft: 0}}>
                              <Label style={{color: "white"}}>Phone No</Label>
                              <Input type="text" id="phoneNumber" name="phoneNumber" placeholder="Mobile phone number" value={phoneNumber} 
                                  onChange={(e) => {
                                      setPhoneNumber(e.target.value);
                                      onInputChange(e);
                                  }}
                              />
                          </Col>
                        </Row>
                      </FormGroup>
                      {showErrors("phoneNumber")}
                      {showServerErrors("phoneNumber")}
                      <div className="text-right">
                        <br/>
                        <Button color="primary" onClick={(event) => doUpdateProfile(event)} ><span className={btnProfileIcon(status)}></span> {btnProfileLabel}</Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    { statusIdentity === "identity/update/succeeded" ? ( <Alert color="success">Setting updated successfully</Alert> ) : ""}
                    { statusIdentity === "identity/update/rejected" ? ( <Alert color="danger">Setting updated failed!</Alert> ) : ""}
                    { checkedPassword === false ? ( <Alert color="danger">New password and confirmation password do not match!</Alert> ) : ""}
                    <Form>
                      <FormGroup>
                        <Label>Old Password*</Label>
                        <Input type="password" id="oldPassword" name="oldPassword" placeholder="your password" value={oldPassword} 
                            onChange={(e) => {
                                setOldPassword(e.target.value);
                                onInputChange(e);
                            }}
                        />
                      </FormGroup>
                      {showErrors("oldPassword")}
                      {showServerErrors("oldPassword")}

                      <FormGroup>
                        <Label>New Password*</Label>
                        <Input type="password" id="newPassword" name="newPassword" placeholder="your new password" value={newPassword} 
                            onChange={(e) => {
                                setNewPassword(e.target.value);
                                onInputChange(e);
                            }}
                        />
                      </FormGroup>
                      {showErrors("newPassword")}
                      {showServerErrors("new_password")}

                      <FormGroup>
                        <Input type="password" id="confirmPassword" name="confirmPassword" placeholder="confirm new password" value={confirmPassword} 
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                onInputChange(e);
                            }}
                        />
                      </FormGroup>
                      {showErrors("confirmPassword")}
                      {showServerErrors("confirm_password")}
                      <div className="text-right">
                        <br/>
                        <Button color="primary" onClick={(event) => doUpdatePassword(event)} ><span className={btnSettingIcon(statusIdentity)}></span>  {btnPasswordLabel}</Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Card>
    </div>
  );
};
